import React, { useEffect, useState } from 'react';
import CommentThread from '../../../../shared/components/comments/CommentThread';
import { createAccountingComment, deleteAccountingComment, listAccountingComments } from '../../services/accounting.service';

export default function AccountingCommentsSection({ entityType, entityId, autoFocus = false }) {
  const [comments, setComments] = useState([]);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    if (!entityId) return undefined;
    listAccountingComments(entityType, entityId).then((result) => {
      if (!active) return;
      setComments(result.ok ? result.data : []); setError(result.ok ? '' : result.message);
    });
    return () => { active = false; };
  }, [entityId, entityType]);
  async function add(payload) {
    const result = await createAccountingComment(entityType, entityId, payload);
    if (result.ok) setComments((items) => [...items, result.data]); else setError(result.message);
    return result;
  }
  async function remove(comment) {
    const result = await deleteAccountingComment(entityType, entityId, comment.id);
    if (result.ok) setComments((items) => items.filter((item) => String(item.id) !== String(comment.id))); else setError(result.message);
    return result;
  }
  return <section className="accounting-detail__section accounting-detail__section--full">
    <CommentThread key={`${entityType}:${entityId}`} autoFocus={autoFocus} title="Commenti" comments={comments} currentUser={null} error={error}
      emptyLabel="Nessun commento presente." placeholder="Scrivi un commento..." submitLabel="Aggiungi commento"
      onSubmitComment={add} onSubmitReply={(parentId, payload) => add({ ...payload, parentId })}
      onDeleteComment={remove} allowReplies />
  </section>;
}
